module.exports = __webpack_public_path__ + "static/media/card_dealt_neon.68ca4965.wav";